import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { Printer } from "lucide-react";

export default function PdpPrint() {
  const { oid } = useParams();
  const [pdp, setPdp] = useState(null);
  useEffect(() => { api.get(`/operations/${oid}/pdp`).then((r) => setPdp(r.data)); }, [oid]);
  if (!pdp) return <div style={{ padding: 40 }} className="mono">Chargement…</div>;

  const S = ({ n, t, children }) => (
    <section style={{ marginTop: 18 }}>
      <h3 style={{ fontSize: "1rem", color: "#136B79", borderBottom: "1px solid #D6E1E1", paddingBottom: 4 }}>{n}. {t}</h3>
      <div style={{ marginTop: 6 }}>{children}</div>
    </section>
  );
  const UL = ({ items }) => items.length ? <ul style={{ margin: 0, paddingLeft: 18, lineHeight: 1.6 }}>{items.map((x, i) => <li key={i}>{x}</li>)}</ul> : <p>—</p>;

  return (
    <div style={{ maxWidth: 820, margin: "0 auto", padding: "30px 26px", fontFamily: "'Instrument Sans',sans-serif", color: "#0E2528", fontSize: ".9rem" }}>
      <div className="no-print" style={{ display: "flex", justifyContent: "flex-end", marginBottom: 16 }}>
        <button className="btn btn-p" onClick={() => window.print()} data-testid="print-btn"><Printer size={15} />Imprimer / Enregistrer en PDF</button>
      </div>
      <h1 style={{ fontFamily: "'Big Shoulders Display'", textTransform: "uppercase", fontSize: "2rem", margin: 0 }}>Plan de Prévention</h1>
      <div style={{ fontFamily: "'Space Mono'", fontSize: ".72rem", color: "#5C6E70", marginBottom: 14 }}>
        {pdp.operation.titre} — Réf. {pdp.ref} · Version {pdp.version} · Statut : {pdp.statutLabel}
      </div>
      <table style={{ width: "100%", borderCollapse: "collapse", fontSize: ".82rem" }}><tbody>
        {[["Site", pdp.operation.site, "Criticité", pdp.operation.criticiteLabel],
          ["Donneur d'ordre", pdp.operation.donneurOrdre, "Période", `${pdp.operation.dateDebut} → ${pdp.operation.dateFin}`],
          ["Entreprise extérieure", pdp.operation.ee, "Sous-traitants", pdp.operation.sousTraitants || "—"]].map((row, i) => (
          <tr key={i}>
            <td style={{ border: "1px solid #D6E1E1", padding: "5px 8px", color: "#5C6E70", width: "18%" }}>{row[0]}</td>
            <td style={{ border: "1px solid #D6E1E1", padding: "5px 8px", width: "32%" }}>{row[1]}</td>
            <td style={{ border: "1px solid #D6E1E1", padding: "5px 8px", color: "#5C6E70", width: "18%" }}>{row[2]}</td>
            <td style={{ border: "1px solid #D6E1E1", padding: "5px 8px" }}>{row[3]}</td>
          </tr>
        ))}
      </tbody></table>

      <S n={1} t="Contexte de l'opération"><p>{pdp.contexte || "—"}</p></S>
      <S n={2} t="Entreprises concernées"><UL items={pdp.entreprises} /></S>
      <S n={3} t="Risques liés aux activités"><UL items={pdp.risquesActivites} /></S>
      <S n={4} t="Risques liés aux lieux"><UL items={pdp.risquesLieux} /></S>
      <S n={5} t="Risques de coactivité">
        {pdp.risquesCoactivite.length ? <ul style={{ paddingLeft: 18, lineHeight: 1.6 }}>{pdp.risquesCoactivite.map((r, i) => <li key={i}><b>[{r.code}]</b> {r.msg}{r.fix && <div style={{ color: "#5C6E70" }}>→ {r.fix}</div>}</li>)}</ul> : <p>Aucune incompatibilité détectée.</p>}
      </S>
      <S n={6} t="Mesures de prévention"><UL items={pdp.mesures} /></S>
      <S n={7} t="Consignes spécifiques"><UL items={pdp.consignes} /></S>
      <S n={8} t="Responsabilités"><UL items={pdp.responsabilites.map((r) => `${r.role} : ${r.nom}`)} /></S>
      <S n={9} t="Validations">
        <table style={{ width: "100%", borderCollapse: "collapse", fontSize: ".82rem" }}>
          <thead><tr>{["Étape", "Responsable", "Statut"].map((h) => <th key={h} style={{ border: "1px solid #D6E1E1", padding: "5px 8px", textAlign: "left", background: "#F2F6F6" }}>{h}</th>)}</tr></thead>
          <tbody>{pdp.validations.map((v, i) => <tr key={i}><td style={{ border: "1px solid #D6E1E1", padding: "5px 8px" }}>{v.etape}</td><td style={{ border: "1px solid #D6E1E1", padding: "5px 8px" }}>{v.nom}</td><td style={{ border: "1px solid #D6E1E1", padding: "5px 8px" }}>{v.statut}</td></tr>)}</tbody>
        </table>
      </S>
      <p style={{ marginTop: 20, fontSize: ".72rem", color: "#5C6E70", borderTop: "1px solid #D6E1E1", paddingTop: 8 }}>
        Document généré par PERMIT&CO — la décision finale d'autorisation reste une décision humaine. {pdp.genereLe && `Généré le ${pdp.genereLe}.`}
      </p>
    </div>
  );
}
